import { getEscHandler } from "@/app/esc_handler"
import { useLockedBody } from "@/app/hooks/locked_body"
import { useCallback, useEffect, useRef } from "react"

export function usePopup(isOpen: boolean, close: () => void) {
  const popupRef = useRef(null)
  const [_, setBodyLock] = useLockedBody(isOpen)

  const closePopup = useCallback(() => {
    setBodyLock(false)
    close()
  }, [close, setBodyLock])

  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        closePopup()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [closePopup, isOpen])

  useEffect(getEscHandler(close))

  return { popupRef, closePopup }
}
